export default "__VITE_ASSET__BANixX_M__"